import { useState } from 'react';
/**
 * True on the render where `inputs` differ (element by element, `Object.is`)
 * from the last render that saw them, including the first — the check an
 * effect's dependency list makes, done while rendering. State set in the same
 * render when it returns true is applied before React commits anything, which
 * is React's pattern for adjusting state when a prop changes instead of a
 * second render from an effect.
 *
 * Every input must keep its identity while it means the same thing (a
 * primitive, state, query data, a memo): a value rebuilt on every render —
 * `const { data = [] } = useQuery(…)` before the answer — re-renders forever.
 */
export function useInputsChanged(inputs) {
    const [seen, setSeen] = useState(null);
    const changed = seen === null || seen.length !== inputs.length || inputs.some((input, index) => !Object.is(input, seen[index]));
    if (changed)
        setSeen(inputs);
    return changed;
}
//# sourceMappingURL=use-inputs-changed.js.map